// src/pages/user/Payments.jsx

import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaCreditCard, FaMoneyBillWave, FaRedo, FaStripe } from 'react-icons/fa';
import { FiCalendar, FiHash, FiCheckCircle, FiClock } from 'react-icons/fi';
import UserMasterLayout from '../../../layout/useradmin/UserMasterLayout';
import AppContext from '../../../context/AppContext.js';
import axios from 'axios';
import '../../../assets/css/useradmin/payments/Payments.css';

const Payments = () => {
  const { baseUrl, loggedInCustomer } = useContext(AppContext);

  const [payments,   setPayments]   = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [activeTab,  setActiveTab]  = useState('history');

  // ── FETCH ─────────────────────────────────────────────────────
  const getCustomerPayments = () => {
    if (!loggedInCustomer) return;
    setLoading(true);
    const token = localStorage.getItem("authToken");

    const formData = new FormData();
    formData.append('srcustomer_id', loggedInCustomer.id);

    axios.post(`${baseUrl}/customer/payments/getCustomerPayments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      if (res.data.success) setPayments(res.data.payments || []);
      else setPayments([]);
      setLoading(false);
    }).catch(() => {
      setPayments([]);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (loggedInCustomer) getCustomerPayments();
  }, [loggedInCustomer]);

  // ── HELPERS ───────────────────────────────────────────────────
  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr; // agar already 'YYYY-MM-DD' string ho to as-is dikha do
    return d.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  // ── COMPUTED ───────────────────────────────────────────────────
  // Backend already sirf payment === 'paid' wali rows bhejta hai,
  // isliye ye client-side filter safety ke liye hai (agar kabhi mix data aaye)
  const paidPayments = payments.filter(p => p.payment === 'paid');
  const totalPaid    = paidPayments.reduce((sum, p) => sum + Number(p.totalprice || 0), 0);

  // ================================================================
  // RETURN
  // ================================================================
  return (
    <UserMasterLayout>
      <Container fluid className="payments-page">

        {/* PAGE HEADER */}
        <div className="page-header">
          <h2>Payments & Billing</h2>
          <p>Manage all your payment transactions</p>
        </div>

        {/* SUMMARY CARDS */}
        <Row className="payment-summary">
          <Col lg={4} md={6} sm={12} className="mb-4">
            <div className="summary-card paid">
              <div className="card-icon"><FaCreditCard /></div>
              <div className="card-info">
                <h3>Rs {totalPaid.toLocaleString()}</h3>
                <p>Total Paid</p>
              </div>
            </div>
          </Col>
          <Col lg={4} md={6} sm={12} className="mb-4">
            <div className="summary-card pending">
              <div className="card-icon"><FaMoneyBillWave /></div>
              <div className="card-info">
                <h3>{paidPayments.length}</h3>
                <p>Total Transactions</p>
              </div>
            </div>
          </Col>
          <Col lg={4} md={6} sm={12} className="mb-4">
            <div className="summary-card refund">
              <div className="card-icon"><FaStripe /></div>
              <div className="card-info">
                <h3>Stripe</h3>
                <p>Payment Method</p>
              </div>
            </div>
          </Col>
        </Row>

        {/* TABS */}
        <div className="payment-tabs-wrapper">
          <div className="payment-tabs">
            <button
              className={`payment-tab ${activeTab === 'history' ? 'active' : ''}`}
              onClick={() => setActiveTab('history')}
            >
              History ({paidPayments.length})
            </button>
          </div>
        </div>

        {/* PAYMENTS LIST */}
        <div className="tab-content-section">
          {loading ? (
            <div className="payments-loading">
              <div className="pay-spinner"></div>
              <p>Loading payments...</p>
            </div>
          ) : paidPayments.length === 0 ? (
            <div className="payments-empty">
              <FaCreditCard size={40} style={{ color: '#ddd', marginBottom: 12 }} />
              <h4>No Payments Found</h4>
              <p>You have not made any payments yet.</p>
            </div>
          ) : (
            <div className="payments-list">
              {paidPayments.map((payment) => (
                <div key={payment.id} className="payment-item">
                  <div className="payment-left">
                    <div className="payment-icon-wrap">
                      <FiCheckCircle size={22} color="#FDB714" />
                    </div>
                    <div className="payment-info">
                      <h4>{payment.srequipmentmanagment?.equipmentname || 'Equipment'}</h4>
                      <div className="payment-meta">
                        <span><FiHash size={12} /> Payment #{payment.id}</span>
                        <span>•</span>
                        <span><FiCalendar size={12} /> {formatDate(payment.created_at)}</span>
                        <span>•</span>
                        <span>Booking Date: {formatDate(payment.bookingdate)}</span>
                      </div>
                      <div className="payment-method-tag">
                        <FaStripe size={13} />
                        <span>Stripe — Online Payment</span>
                      </div>
                    </div>
                  </div>
                  <div className="payment-right">
                    <span className="payment-amount">Rs {Number(payment.totalprice).toLocaleString()}</span>
                    <span className="status-badge completed">
                      <span className="status-dot"></span>
                      PAID
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )} 
        </div>

      </Container>
    </UserMasterLayout>
  );
};

export default Payments;